import {Injectable}                          from '@angular/core';
import {ApStatsType}                         from '../../../ap-interface';
import {IStatisticBatchItem, StatisticStore} from '../../../stores/statistic/statistic.store';
import {ApDynGridColumnConfigBase}           from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApDynGridPropertyColumnConfig}       from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {IGenericTableStatsConfig}            from '../charts/ap-generic-table-stats/ap-generic-table-stats.component';
import {nameOf}                              from '../../../ap-core/utils/ap-name-of';
import {
  ApPpPlanningWizardOverviewStatsItem
}                                            from '../charts/plant-protection/types/ap-pp-planning-wizard-overview-stats.types';

@Injectable({providedIn: 'root'})
export class PpPlanningWizardOverviewStatisticService {

  constructor(private statisticStore: StatisticStore) {
  }

  /**
   * Builds and publishes the plant-protection planning-wizard overview as a single
   * headerless key/value GenericTableStats batch item. Values may be multiline.
   * @param title - header shown above the cell; also used as the empty fallback title.
   * @param items - key/value rows; an empty/missing list publishes an empty batch.
   * @param emptyMessage - fallback text shown when no rows are present.
   * @public
   */
  public generateStats(title: string, items: ApPpPlanningWizardOverviewStatsItem[], emptyMessage = ''): void {
    if (!items || items.length <= 0) {
      this.statisticStore.setStatisticDataBatch([], title, emptyMessage);
      return;
    }
    const config: IGenericTableStatsConfig = {renderMode: 'grid', hideHeader: true};
    const batchItem: IStatisticBatchItem<{
      columns: ApDynGridColumnConfigBase[];
      items: ApPpPlanningWizardOverviewStatsItem[];
      config: IGenericTableStatsConfig;
    }> = {
      data: {columns: this.getStatColumns(), items, config},
      type: ApStatsType.GenericTableStats
    };
    this.statisticStore.setStatisticDataBatch([batchItem], title, emptyMessage);
  }

  /**
   * Builds the two-column key/value grid configuration: a bold key column on a
   * base-colored background and a multiline value column.
   * @return The grid column configurations.
   * @private
   */
  private getStatColumns(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        field: nameOf<ApPpPlanningWizardOverviewStatsItem>('key'),
        style: {'font-weight': 600, 'background-color': 'var(--kendo-color-base)'},
        cssClass: 'left',
        width: 100,
        filterable: false,
        sortable: false
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<ApPpPlanningWizardOverviewStatsItem>('value'),
        cssClass: 'left',
        filterable: false,
        sortable: false,
        multiline: true
      })
    ];
  }
}
